'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Timeline = exports.TimelineEvent = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _Circle = require('../Circle');

var _Circle2 = _interopRequireDefault(_Circle);

require('./styles.sass');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TimelineEvent = exports.TimelineEvent = function TimelineEvent(_ref) {
  var date = _ref.date,
      children = _ref.children,
      completed = _ref.completed;
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)('TimelineEvent', completed && 'TimelineEvent--completed') },
    _react2.default.createElement(
      'div',
      { className: 'TimelineEvent__line-container' },
      _react2.default.createElement('div', { className: 'TimelineEvent__line' }),
      _react2.default.createElement(_Circle2.default, { filled: true, size: 18, className: 'TimelineEvent__circle' })
    ),
    _react2.default.createElement(
      'div',
      { className: 'TimelineEvent__text' },
      _react2.default.createElement(
        'div',
        { className: 'TimelineEvent__date' },
        (0, _moment2.default)(date).format('L')
      ),
      children
    )
  );
};

TimelineEvent.propTypes = {
  date: _propTypes2.default.any.isRequired,
  children: _propTypes2.default.node,
  completed: _propTypes2.default.bool
};

var Timeline = exports.Timeline = function Timeline(_ref2) {
  var children = _ref2.children;
  return _react2.default.createElement(
    'div',
    { className: 'Timeline' },
    children
  );
};

Timeline.propTypes = {
  children: _propTypes2.default.node
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/components/Timeline/index.js
// module id = 625
// module chunks = 0